<template>
  <v-btn outlined color="success" @click="$emit('click')"> <v-icon left>mdi-file-excel</v-icon> Xuất Excel </v-btn>
</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash'
import ExcelJS from 'exceljs'
import moment from 'moment'

export default {
  props: {
    query: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      list: [],
      factorsRaw: []
    }
  },
  computed: {
    ...mapState('ClassMark', ['studentMarks', 'factors', 'isClassExtraCurriculum'])
  },
  methods: {
    async getData() {
      this.factorsRaw = Object.values(this.factors).map(v => {
        if (v.type === 'factor-1') return { ...v, short_title: 'ĐĐGtx' }
        if (v.type === 'factor-2') return { ...v, short_title: 'ĐĐGgk' }
        if (v.type === 'factor-3') return { ...v, short_title: 'ĐĐGck' }
      })
      if (this.studentMarks.length) {
        this.list = this.studentMarks.map(v => {
          let listMarks = v.marks.map(x => ({ value: get(x, 'value', ''), factor: get(x, 'factor.id') }))
          return {
            student: v.student,
            marks: listMarks
          }
        })
        this.onExportExcel()
      }
    },

    getInfo() {
      const className = get(this.query, 'class.title', '')
      const schoolYear = get(this.query, 'semester.schoolYear.description', '')
      const semester = get(this.query, 'semester.title', '')
      const subject = get(this.query, 'subject.title', '')
      const subjectGroup = get(this.query, 'subject.subjectGroup.title')
      return { className, schoolYear, semester, subject, subjectGroup }
    },

    getTitle(worksheet) {
      const { className, schoolYear, semester, subject, subjectGroup } = this.getInfo()
      const description11 = 'SỞ GIÁO DỤC VÀ ĐÀO TẠO HẢI PHÒNG'
      const description12 = 'TRƯỜNG TH&THCS TÂN PHONG'
      const description13 = `Lớp: ${className} ${subject}`

      const description21 = 'BẢNG ĐIỂM HỌC KỲ'
      const description22 = schoolYear && semester ? `${schoolYear} - ${semester}` : ''
      const description23 = `Môn học: ${subjectGroup} - GV: Quản trị đơn vị`

      worksheet.addRow([description11, '', '', description21, '', ''])
      worksheet.mergeCells(1, 1, 1, 3)
      worksheet.mergeCells(1, 4, 1, 7)

      worksheet.addRow([description12, '', '', description22, '', ''])
      worksheet.mergeCells(2, 1, 2, 3)
      worksheet.mergeCells(2, 4, 2, 7)

      worksheet.addRow([description13, '', '', description23, '', ''])
      worksheet.mergeCells(3, 1, 3, 3)
      worksheet.mergeCells(3, 4, 3, 7)

      worksheet.getCell('A1').alignment = { horizontal: 'left' }
      worksheet.getCell('D1').alignment = { horizontal: 'center' }

      worksheet.getCell('A2').alignment = { horizontal: 'left' }
      worksheet.getCell('D2').alignment = { horizontal: 'center' }

      worksheet.getCell('A3').alignment = { horizontal: 'left' }
      worksheet.getCell('D3').alignment = { horizontal: 'center' }
      worksheet.addRow([])
    },

    setHeader(worksheet) {
      worksheet.getRow(5).eachCell(cell => {
        cell.alignment = { horizontal: 'center', vertical: 'middle' }
        cell.font = { bold: true }
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }

        let selectedHeaders = ['STT', 'Mã định danh', 'Họ và tên', 'Ngày sinh']
        // if (this.isClassExtraCurriculum) selectedHeaders.push('Lớp')
        if (selectedHeaders.includes(cell.value)) {
          cell.font = { bold: true, color: { argb: 'FFFF0000' } }
        } else {
          cell.font = { bold: true }
        }
      })
    },

    settingCells(worksheet) {
      worksheet.getColumn(1).eachCell((cell, rowNumber) => {
        if (rowNumber >= 6) {
          cell.alignment = { horizontal: 'center', vertical: 'middle' }
        }
      })
      worksheet.getRow(5).height = 60

      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 4) {
          row.eachCell(cell => {
            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            }
          })
        }
      })
    },

    getContentDataRow({ factors, maxCounts, student, index, isEvaluate = false }) {
      const row = [
        String(index + 1),
        student.student.code,
        student.student.name,
        moment(student.student.dob).format('DD/MM/YYYY')
      ]

      // if (this.isClassExtraCurriculum) {
      //   row.push(get(student, 'student.currentClassTitle', ''))
      // }

      factors.forEach((factor, factorIndex) => {
        const marks = student.marks.filter(mark => mark.factor === factor.id)

        if (marks.length === 0) {
          for (let i = 0; i < maxCounts[factorIndex]; i++) {
            row.push('')
          }
        } else {
          marks.forEach(mark => {
            let markValue = ''
            if (!isEvaluate) markValue = mark.value || ''
            else {
              const meaning = this.$options.filters.getEvaluate(mark.value)
              if (meaning !== '---') markValue = meaning
            }
            row.push(markValue)
          })

          for (let i = marks.length; i < maxCounts[factorIndex]; i++) {
            row.push('')
          }
        }
      })

      return row
    },

    async onExportExcel() {
      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('Marks')

      this.getTitle(worksheet)
      const header = ['STT', 'Mã định danh', 'Họ và tên', 'Ngày sinh']
      // if (this.isClassExtraCurriculum) header.push('Lớp')
      const factors = this.factorsRaw.map(v => ({ id: v.id, title: v.short_title }))
      const marksHeader = []
      const marksData = []
      const maxCounts = Array(factors.length).fill(0)
      this.list.forEach(student => {
        factors.forEach((factor, factorIndex) => {
          const count = student.marks.filter(mark => mark.factor === factor.id).length
          maxCounts[factorIndex] = Math.max(maxCounts[factorIndex], count, 1)
        })
      })

      factors.forEach((factor, index) => {
        marksHeader.push(factor.title)
        for (let i = 0; i < maxCounts[index] - 1; i++) {
          marksHeader.push('')
        }
      })

      const isEvaluate = get(this.query, 'subject.markType') === 'evaluate'
      this.list.forEach((student, index) => {
        const row = this.getContentDataRow({ factors, maxCounts, student, index, isEvaluate })
        marksData.push(row)
      })

      worksheet.addRow(header.concat(marksHeader))
      marksData.forEach(row => {
        worksheet.addRow(row)
      })

      let colIndex = header.length
      factors.forEach((_, index) => {
        if (maxCounts[index] > 1) {
          worksheet.mergeCells(5, colIndex + 1, 5, colIndex + maxCounts[index])
        }
        colIndex += maxCounts[index]
      })

      this.setHeader(worksheet)
      this.settingCells(worksheet)

      worksheet.columns = [
        { width: 10 },
        { width: 15 },
        { width: 30 },
        { width: 15 },
        ...marksHeader.map(() => ({ width: 10 }))
      ]

      this.onDownload(workbook)
    },

    async onDownload(workbook) {
      const { className, semester, subjectGroup } = this.getInfo()
      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `Bảng điểm ${subjectGroup} lớp ${className} HK ${semester}.xlsx`
      link.click()
      this.$emit('onExportSuccess')
    }
  }
}
</script>
